import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseSiteService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { StsAdminService } from '../sts-admin.service';

@Component({
  selector: 'app-sts-shipping-commitment',
  templateUrl: './sts-shipping-commitment.component.html',
  styleUrls: ['./sts-shipping-commitment.component.scss'],
})
export class StsShippingCommitmentComponent implements OnInit, OnDestroy {
  customerDetails: any = [];
  customerDataSubscription: any;
  file: File;
  data: any;
  disable: boolean;
  fileUploadForm = this.fb.group({
    excelUploadFile: [''],
  });
  excelFileInvalidStatus: boolean = false;

  maxSelectionDate = new Date();
  startDate: any;
  shippingCommitSubscription: Subscription;
  shippingData: any = [];
  deleteShipCommitSubs: Subscription;
  pageSize: any = 10;
  filters: { fields: string; currentPage: any; pageSize: any };
  currentPage: any = 1;
  totalOrders: any;
  end: any;
  uploadRes: any = '';
  uploadTimeout: any;
  isLoadingDone: boolean = false;
  baseSiteId: string;
  baseSub: Subscription;
  excelSub: Subscription;
  stsSub: Subscription;
  stsAdminSub: Subscription;

  constructor(
    private readonly stsAdminService: StsAdminService,
    private readonly cd: ChangeDetectorRef,
    public excelService: ExcelDownloadService,
    private readonly modal: NgbModal,
    private readonly fb: FormBuilder,
    private readonly globalMessage: GlobalMessageService,
    private readonly datePipe: DatePipe,
    private readonly baseSite: BaseSiteService
  ) {
    this.disable = false;
  }
  ngOnInit(): void {
    this.baseSub = this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.getShippingCommit();
  }

  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.shippingCommitSubscription?.unsubscribe();
    this.excelSub?.unsubscribe();
    this.stsSub?.unsubscribe();
    this.stsAdminSub?.unsubscribe();
    this.deleteShipCommitSubs?.unsubscribe();
  }
  getShippingCommit() {
    this.isLoadingDone = false;
    this.filters = {
      fields: 'DEFAULT',
      currentPage: this.currentPage - 1,
      pageSize: this.pageSize,
    };
    this.end = this.pageSize;
    this.stsAdminService.getShippingCommitment(this.filters);
    this.shippingCommitSubscription =
      this.stsAdminService.shippingCommitData$.subscribe((res) => {
        this.isLoadingDone = true;
        if (res !== null) {
          this.shippingData = res.fluShipinfo;
          this.totalOrders = res?.pagination?.totalResults;
          this.shippingData.forEach((element) => {
            element.active = false;
            element.notFocused = [false, false, false, false, false];
            element.previousContractNumber = element.contractNumber;
            element.previousStartDate = element.startDate;
            element.previousEndDate = element.endDate;
            element.previousMaterialNumber = element.materialNumber;
            element.previousPercentage = element.percentage;
          });
          if (this.pageSize > this.totalOrders) {
            this.end = this.totalOrders;
          } else {
            if (this.pageSize < this.totalOrders) {
              this.end = this.pageSize * this.currentPage;
              if (this.end > this.totalOrders) {
                this.end = this.totalOrders;
              }
            }
          }
          this.cd.detectChanges();
        }
      });
  }

  getCurrentPage(type) {
    this.currentPage =
      type === 'prev' ? this.currentPage - 1 : this.currentPage + 1;
    this.cd.detectChanges();
    this.getShippingCommit();
  }

  downloadExcel() {
    this.excelSub = this.stsAdminService
      .downloadExcelShipCommit()
      .subscribe((res) => {
        if (res != null) {
          let array = [];
          res.fluShipinfo.forEach((element) => {
            let data = {
              'Contract Number': element?.contractNumber,
              'Presentation Code': element?.materialNumber,
            };
            element.fluShipingInfo.forEach((shipElement, index) => {
              data['Start Date ' + (index + 1)] = shipElement.startDate;
              data['End Date ' + (index + 1)] = shipElement.endDate;
              data['Qty Pct ' + (index + 1)] = shipElement.percentage;
            });
            array.push(data);
          });
          this.excelService.exportAsExcelFile(
            array,
            'Shipping_commitment_output_file_' + new Date(),
            true
          );
        }
      });
  }

  hideModal() {
    this.modal.dismissAll();
    this.refreshValue();
  }

  openModal(content) {
    this.modal.open(content, {
      centered: true,
      backdrop: 'static',
      windowClass: `${this.baseSiteId}`,
    });
  }

  uploadFileDetails() {
    let selectedFile: File = this.file;
    let formData: FormData = new FormData();
    formData.append('selectedFile', selectedFile, selectedFile.name);
    this.disable = true;
    this.stsSub = this.stsAdminService
      .shippingCommitUploadFile(formData)
      .subscribe(
        (res) => {
          this.uploadRes = res;
          if (res.status == 'success') {
            // this.globalMessage.add('Customer upload is in progress. The status will be notified via email', GlobalMessageType.MSG_TYPE_CONFIRMATION);
            this.getShippingCommit();
          } else if (res.status == 'failure') {
            res.errors.forEach((element) => {
              this.globalMessage.add(element, GlobalMessageType.MSG_TYPE_ERROR);
            });
            //getting updated data in both success and failure.
            //as in failure case also from backend data is getting updated.
            clearTimeout(this.uploadTimeout);
            this.uploadTimeout = setTimeout(() => {
              this.getShippingCommit();
            }, 1500);
            this.cd.detectChanges();
          } else {
            clearTimeout(this.uploadTimeout);
            this.uploadTimeout = setTimeout(() => {
              this.getShippingCommit();
            }, 1500);
            this.globalMessage.add(
              res.status,
              GlobalMessageType.MSG_TYPE_ERROR
            );
            this.cd.detectChanges();
          }
          this.hideModal();
          this.refreshValue();
          this.disable = false;
        },
        (err) => {
          this.hideModal();
          this.refreshValue();
          this.disable = false;
          err.errors.forEach((element) => {
            this.globalMessage.add(element, GlobalMessageType.MSG_TYPE_ERROR);
          });
          this.cd.detectChanges();
        }
      );
  }
  onFileSelect(event) {
    this.uploadRes = '';
    if (event.target.files.length > 0) {
      this.file = (event.target as HTMLInputElement).files[0];
      this.fileUploadForm.get('excelUploadFile').setValue(this.file.name);
      const fileParts = this.file.name.split('.');
      const extension = fileParts[fileParts.length - 1].trim().toLowerCase();
    }
  }
  refreshValue() {
    this.fileUploadForm.get('excelUploadFile').setValue('');
    this.cd.detectChanges();
  }

  update(data, i) {
    data.active = true;
    data.notFocused = [true, true, true, true, true];

    if (
      data.percentage == '' ||
      data.percentage == null ||
      data.materialNumber == '' ||
      data.materialNumber == null ||
      data.startDt === '' ||
      data.endDt === '' ||
      data.startDt === undefined ||
      data.endDt === undefined ||
      this.dateCheck(data) ||
      new Date(data.startDt).getDay() !== 1 ||
      new Date(data.endDt).getDay() !== 1 ||
      this.allowNumber(data.percentage) ||
      this.materialRegex(data.materialNumber)
    ) {
      return;
    }

    data.active = false;

    let params = {
      previousContractNumber: data?.previousContractNumber,
      previousEndDate: data?.previousEndDate,
      startDate:
        this.datePipe.transform(data.startDt, 'yyyy-MM-ddTh:mm:ss') + '+0000',
      endDate:
        this.datePipe.transform(data.endDt, 'yyyy-MM-ddTh:mm:ss') + '+0000',
      percentage: data?.percentage,
      materialNumber: data?.materialNumber,
      previousMaterialNumber: data?.previousMaterialNumber,
      previousPercentage: data?.previousPercentage,
      salesOrg: data?.salesOrg,
      previousStartDate: data?.previousStartDate,
      contractNumber: data?.contractNumber,
    };
    this.stsAdminSub = this.stsAdminService.updateShipCommit(params).subscribe(
      (res) => {
        if (res !== null) {
          if (res.status.toLowerCase() !== 'failure') {
            this.globalMessage.add(
              'Record is updated successfully.',
              GlobalMessageType.MSG_TYPE_CONFIRMATION
            );
            this.getShippingCommit();
          } else {
            res.errors.forEach((element) => {
              this.globalMessage.add(element, GlobalMessageType.MSG_TYPE_ERROR);
            });
          }
        }
      },
      (err) => {
        err.errors.forEach((element) => {
          this.globalMessage.add(element, GlobalMessageType.MSG_TYPE_ERROR);
        });
      }
    );
  }
  delete(data, i) {
    let params = {
      previousContractNumber: data?.previousContractNumber,
      previousEndDate: data?.previousEndDate,
      materialNumber: data?.materialNumber,
      previousMaterialNumber: data?.previousMaterialNumber,
      previousPercentage: data?.previousPercentage,
      salesOrg: data?.salesOrg,
      previousStartDate: data?.previousStartDate,
      contractNumber: data?.contractNumber,
    };
    this.stsAdminService.deleteShipCommit(params);
    this.deleteShipCommitSubs =
      this.stsAdminService.deleteShippingCommit$.subscribe(
        (res) => {
          if (res) {
            this.getShippingCommit();
          }
        },
        (err) => {
          err.errors.forEach((element) => {
            this.globalMessage.add(element, GlobalMessageType.MSG_TYPE_ERROR);
          });
        }
      );
  }

  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
  dateCheck(data) {
    if (new Date(data.startDt) > new Date(data.endDt)) {
      return true;
    }
    return false;
  }
  startDateValidation(data) {
    if (
      data.startDt !== '' &&
      data.startDt !== undefined &&
      !this.dateCheck(data) &&
      new Date(data.startDt).getDay() !== 1
    ) {
      return true;
    }
    return false;
  }
  endDateValidation(data) {
    if (
      data.endDt !== '' &&
      data.endDt !== undefined &&
      !this.dateCheck(data) &&
      new Date(data.endDt).getDay() !== 1
    ) {
      return true;
    }
    return false;
  }

  focusValidation(data, index) {
    data.notFocused[index] = false;
  }

  allowNumber(value) {
    const reg = new RegExp('^[0-9]+$');
    let data = reg.test(value);
    if (value !== '' && value !== null && (value > 100 || !data)) {
      return true;
    }
    return false;
  }

  materialRegex(value) {
    const reg = new RegExp('^[0-9]{3}-[0-9]{2}');
    let data = reg.test(value);
    if (value !== '' && value !== null && !data) {
      return true;
    }
    return false;
  }
}
